/**
 * Single source of truth for every AI model id used in this repo.
 * Imported by prism-api (workers/src), the warehouse workers, the image matcher,
 * Prism Trac and the pricing workers. Change a model here, run the tests, then
 * redeploy each worker that uses it.
 *
 * Prefer undated aliases. A dated snapshot retires on a fixed day and then returns
 * 404 (claude-sonnet-4-20250514 retired 2026-06-15 and silently broke 3 call sites).
 */

// Every Sonnet call: pricing (condition read, vision identify retry, candidates, brand identify),
// tickets, returns, inventory titles, feedback, repairs, listing copy, image matcher, Trac digest.
// A request on this model must send CLAUDE_SONNET_THINKING and read the reply by block type.
export const CLAUDE_SONNET_MODEL = 'claude-sonnet-5-5';
// Sonnet 5.5 rejects thinking 'disabled'. 'between_tools' is its no-thinking setting: it keeps
// latency and the max_tokens budget as they were on Sonnet 4.6. Only Sonnet 5.5 accepts it,
// so change this together with CLAUDE_SONNET_MODEL.
export const CLAUDE_SONNET_THINKING = { type: 'between_tools' };

// Pricing worker: comp classifier, segment classifier, category fallback. prism-api: ticket topics.
export const CLAUDE_HAIKU_MODEL = 'claude-haiku-5-5';

// Pricing worker: vision identify when vision_engine = openai.
// Moved gpt-4o -> gpt-5.5 -> gpt-6.1-sol on 2026-10-08. On 40 past quotes sol named the same
// products as gpt-5.5 at about 40% of the cost.
export const OPENAI_VISION_MODEL = 'gpt-6.1-sol';
// Pricing worker: reverse-image identify, with web search.
// The cost rates in second-opinion.js (costFromUsage RATES) must list this model.
export const OPENAI_WEB_SEARCH_MODEL = 'gpt-5.5';
// Pricing worker: second opinion price, with web search, default effort. Moved from gpt-5.5
// on 2026-10-08: $0.23 a call against $0.59, close answers on 15 of 17 trial items
// (docs/analysis/20261008_second_opinion_cost). costFromUsage RATES must list this model.
export const OPENAI_SECOND_OPINION_MODEL = 'gpt-6.1-sol';
// Pricing worker: OCR, only when ocr_engine = gpt (the default engine is Azure OCR).
export const OPENAI_OCR_MODEL = 'gpt-4o';
// Pricing worker: reverse-image identify when reverse_image_provider = gemini.
export const GEMINI_IDENTIFY_MODEL = 'gemini-pro-latest';

// card-blurb worker (Workers AI).
export const WORKERS_AI_BLURB_MODEL = '@cf/meta/llama-3.3-70b-instruct-fp8-fast';

// LLM SP trial (pricing worker): adaptive thinking with default effort, as in the spike that
// set the trial's prompt. The repo-wide CLAUDE_SONNET_THINKING is 'between_tools' (no thinking),
// so the trial names its own. Do not change it mid-trial: it would end the trial (new prompt version).
export const CLAUDE_SONNET_ADAPTIVE_THINKING = { type: 'adaptive' };
